export const DATE_TIMEZONE_FORMAT = 'YYYY-MM-DD HH:mm:SS ZZ';

export const PARTNERSHIP_TYPE = {
  product: 'product',
};

export const PLACEHOLDER_IMG_URL = `${process.env.REACT_APP_URL}/assets/images/trend-placeholder-img.jpg`;
